export default {
    primary: '#6b59cc',
    secondary: '',
    white: '#fff',
    black:'#000000',
    warning:'#cc3300',
    danger:'#ff0000',
    inactive:'#c3c3c3',
    themecolor:'#6B59CC'
  };